import { LUDUM_CALENDAR_VIEWS } from '@/constants';
const { MONTH } = LUDUM_CALENDAR_VIEWS;
import { toUnixMillis } from '@/helpers/timeFormaterHelper';
import get from 'get-object-path';
import { DateTime } from 'luxon';
import { LUDUM_QUICK_ASSIGN_TYPES } from '../../constants';
const { ATHLETE, COACH, SQUAD, EVERYBODY } = LUDUM_QUICK_ASSIGN_TYPES;

const calendarFilter = localStorage.getItem('ludum-calendar-filter');

export const calendar = {
    state: {
        agendaCounter: 0,
        currentDate: DateTime.now(),
        previousCalendarView: null,
        calendarView: MONTH,
        agendaItems: [],
        sessionsToAssign: [],
        weeklySummaryMonth: '',

        filter: calendarFilter
            ? JSON.parse(calendarFilter)
            : {
                  event_tag_ids: [],
                  athlete_ids: [],
                  start_date: null,
                  end_date: null,
                  display: 'my-sessions',
                  session_types: [],
                  speedIntensities: [],
                  hrIntensities: [],
                  srIntensities: [],
                  focuses: [],
                  squad_ids: [],
                  creator_ids: [],
                  selectedCreatorBy: [],
                  selectedMembers: [],
                  selectedSquads: []
              },

        selectAllAgendaSessions: false
    },

    getters: {
        agendaCounter(state) {
            return state.agendaCounter;
        },

        agendaItems(state) {
            return _.sortBy(state.agendaItems, 'start_date');
        },

        calendarView(state) {
            return state.calendarView;
        },

        previousCalendarView(state) {
            return state.previousCalendarView;
        },

        currentDate(state) {
            return state.currentDate;
        },

        calendarFilter(state) {
            return state.filter;
        },

        calendarWeeklySummaryMonth(state) {
            return state.weeklySummaryMonth;
        },

        sessionsToAssign(state) {
            return _.sortBy(state.sessionsToAssign, 'start_date');
        },

        selectAllAgendaSessions(state) {
            return state.selectAllAgendaSessions;
        }
    },

    mutations: {
        raiseAgendaCounter(state) {
            state.agendaCounter += 1;
        },

        resetCalendarState(state) {
            state.agendaCounter = 0;
            state.selectAllAgendaSessions = false;
            state.currentDate = DateTime.now();
            state.calendarView = MONTH;
            state.previousCalendarView = null;
            state.agendaItems = [];
            state.sessionsToAssign = [];
            state.weeklySummaryMonth = '';
            state.filter = {
                event_tag_ids: [],
                athlete_ids: [],
                start_date: null,
                end_date: null,
                display: 'my-sessions',
                session_types: [],
                speedIntensities: [],
                hrIntensities: [],
                srIntensities: [],
                focuses: [],
                squad_ids: [],
                creator_ids: [],
                selectedCreatorBy: [],
                selectedMembers: [],
                selectedSquads: []
            };
        },

        setFilterStartDate(state, date) {
            state.filter.start_date = date;
        },

        setFilterEndDate(state, date) {
            state.filter.end_date = date;
        },

        saveWeeklySummaryMonth(state, month) {
            state.weeklySummaryMonth = month;
        },

        saveCurrentDate(state, date) {
            state.currentDate = date;
        },

        saveCurrentView(state, view) {
            state.previousCalendarView = state.calendarView;
            state.calendarView = view;
        },

        agendaItems(state, data) {
            state.agendaItems = [];
            data.forEach(item => {
                !state.agendaItems.some(({ id }) => id === item.id) && state.agendaItems.push(Object.freeze(item));
            });
        },

        assignSession(state, data) {
            if (!state.sessionsToAssign.find(({ id }) => id === data.id)) {
                state.sessionsToAssign.push(data);
            }
        },

        unassignSession(state, data) {
            state.sessionsToAssign = state.sessionsToAssign.filter(n => n.id !== data.id);
        },

        resetSessionsToAssign(state) {
            state.sessionsToAssign = [];
        },

        clearFilters(state) {
            state.filter = {
                event_tag_ids: [],
                athlete_ids: [],
                start_date: null,
                end_date: null,
                display: 'my-sessions',
                session_types: [],
                speedIntensities: [],
                hrIntensities: [],
                srIntensities: [],
                focuses: [],
                squad_ids: [],
                creator_ids: [],
                selectedCreatorBy: [],
                selectedMembers: [],
                selectedSquads: []
            };
        },

        setAllSelectedMembersForCalendarFilter(state, selectedMembers) {
            state.filter.selectedMembers = selectedMembers;

            if (selectedMembers.find(({ type }) => type === LUDUM_QUICK_ASSIGN_TYPES.EVERYBODY)) {
                state.filter.user_ids = [];
            } else {
                state.filter.user_ids = selectedMembers.map(({ id }) => id);
            }
        },

        setAllSelectedSquadsForCalendarFilter(state, selectedSquads) {
            state.filter.selectedSquads = selectedSquads;
            if (selectedSquads.length == 0) {
                state.filter.squad_ids = [];
            } else {
                state.filter.squad_ids = selectedSquads.map(({ id }) => id);
            }
        }
    },

    actions: {
        scrollToToday(context) {
            const today = DateTime.now().valueOf();
            const items = _.sortBy(context.getters.agendaItems, o => Math.abs(toUnixMillis(o.start_date) - today));
            if (!items.length) return;

            const element = document.querySelector(`[data-date="${toUnixMillis(items[0].start_date)}"]`);
            element && element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },

        selectAllAgendaSessions(context) {
            const editableSessions = context.rootGetters['userPermissions/canViewEditAllSessions']
                ? context.getters.agendaItems
                : context.getters.agendaItems.filter(item => get(item, 'user_actions.data.edit'));

            editableSessions.forEach(item => {
                if (!context.state.selectAllAgendaSessions) {
                    context.commit('assignSession', item);
                } else {
                    context.commit('unassignSession', item);
                }
            });

            context.state.selectAllAgendaSessions = !context.state.selectAllAgendaSessions;
        }
    }
};

export default calendar;
